import type { RouteLocationRaw } from 'vue-router';

import { Constants } from '@/constants';

/**
 * Module type enum - represents the different types of project modules
 */
export enum ModuleTypeEnum {
  Text = Constants.Block.Type.Text,
  Video = Constants.Block.Type.Video,
  Consultation = Constants.Block.Type.Consultation,
  Attachments = Constants.Block.Type.Attachments,
  Faq = Constants.Block.Type.Faq,
  Subscription = Constants.Block.Type.Subscription,
  Timeline = Constants.Block.Type.Timeline,
  ContactList = Constants.Block.Type.ContactList,
  Hero = Constants.Block.Type.Hero,
  Event = Constants.Block.Type.Event,
  Feedback = Constants.Block.Type.Feedback,
  News = Constants.Block.Type.News,
  QuestionAnswer = Constants.Block.Type.QuestionAnswer,
  Map = Constants.Block.Type.Map,
  DocumentSubmission = Constants.Block.Type.DocumentSubmission,
}

/** The kind of a block's parent: a project (a template is one) or a page. */
export type BlockParentType = (typeof Constants.Block.ParentType)[keyof typeof Constants.Block.ParentType];

/** What a block belongs to: its `parent_type` and `parent_id`. */
export interface BlockParent {
  type: BlockParentType;
  id: number;
}

/** Where one of a parent's blocks opens: the screen that lists the blocks builds it, as it knows its own routes. */
export type BlockRouteFor = (blockId: number) => RouteLocationRaw;

/**
 * Type option for module types
 */
export interface ModuleTypeOption {
  value: ModuleTypeEnum;
  label: string;
}
